var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handsontable-wrap",class:{ 'handsontable-wrap_full-size': _vm.fullSize }},[_c('div',{ref:"mountPoint",attrs:{"id":_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }